import { render, staticRenderFns } from "./UiTextarea.vue?vue&type=template&id=4e7cd527&lang=pug&"
import script from "./UiTextarea.vue?vue&type=script&lang=ts&"
export * from "./UiTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports